import React, { useEffect, useRef } from "react"
import { gsap } from "gsap"

export function ScrollPrompt() {
  const ref = useRef()

  useEffect(() => {
    const el = ref.current
    let timeout

    const show = () => {
      if (window.scrollY > window.innerHeight * 0.5) return
      gsap.to(el, { autoAlpha: 1, duration: 0.8, ease: "power2.out" })
    }

    const hide = () => {
      gsap.to(el, { autoAlpha: 0, duration: 0.4, ease: "power2.in" })
    }

    const resetTimer = () => {
      hide()
      clearTimeout(timeout)
      timeout = setTimeout(show, 500)
    }

    timeout = setTimeout(show, 500)

    window.addEventListener("mousemove", resetTimer)
    window.addEventListener("keydown", resetTimer)
    window.addEventListener("scroll", resetTimer, { passive: true })
    window.addEventListener("touchstart", resetTimer, { passive: true })

    return () => {
      clearTimeout(timeout)
      window.removeEventListener("mousemove", resetTimer)
      window.removeEventListener("keydown", resetTimer)
      window.removeEventListener("scroll", resetTimer)
      window.removeEventListener("touchstart", resetTimer)
    }
  }, [])

  return (
    <div ref={ref} className="scroll-prompt">
      <span className="scroll-prompt-label">scroll</span>
      <svg className="scroll-prompt-arrow" width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="8" y1="0" x2="8" y2="18" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
        <polyline points="2,13 8,20 14,13" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  )
}
